export const RoutePath = {
  dashboard: '/',
  expertProfile: '/profile/:slug',
  // newProfile:'/expert-profile/:slug/BrowseSingleExpertLatest'
  newProfile:'/:slug'
};
